export default __webpack_public_path__ + "public/images/logo-academy.png?8f1dd63c";